import React from "react"
import { renderValidationClass } from "../../util/onboarding_utils"

const InviteMemberRow = props => {
    const {
        id,
        isValid,
        value,
        refCallback,
        removeInviteMemberRow,
        showLabel,
    } = props
    return (
        <div className="invite-member-wrapper-outer">
            <div className="invite-member-wrapper">
                <div className="col-md-6 form-group email">
                    <input
                        value={value}
                        type="email"
                        id={`email${id}`}
                        className={`form-control ${renderValidationClass(isValid)}`}
                        placeholder="name@example.com"
                        onChange={v => {
                            props.onChangeAction(v.target.value, id, "email")
                        }}
                        onBlur={v => {
                            props.handleBlur(v.target.value, id, "email")
                        }}
                        ref={refCallback}
                    />
                </div>
                <div className="col-md-6 form-group name">
                    <input
                        type="name"
                        id={`fullName${id}`}
                        className="form-control"
                        placeholder="Name (optional)"
                        onChange={v => {
                            props.onChangeAction(v.target.value, id, "fullName")
                        }}
                    />
                </div>
            </div>
            {window.innerWidth >= 760 && (
                <div className={`x-wrapper form-group ${showLabel && "first-x"}`}>
                    <DeleteIcon id={id} action={removeInviteMemberRow} />
                </div>
            )}      
        </div>  
    )
}

export default InviteMemberRow

export const DeleteIcon = ({ id, action }) => {
    return (
        <div className="inline-icon-x" onClick={() => action(id)} id={`${id}`}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M10.4942 8L15.4795 3.01473C16.1613 2.33293 16.1713 1.20621 15.4825 0.517464C14.789 -0.176086 13.6757 -0.169903 12.9853 0.520549L8 5.50582L3.01473 0.520549C2.33293 -0.16125 1.20621 -0.171284 0.517464 0.517464C-0.176086 1.21101 -0.169903 2.32428 0.520549 3.01473L5.50582 8L0.520549 12.9853C-0.16125 13.6671 -0.171284 14.7938 0.517464 15.4825C1.21101 16.1761 2.32428 16.1699 3.01473 15.4795L8 10.4942L12.9853 15.4795C13.6671 16.1613 14.7938 16.1713 15.4825 15.4825C16.1761 14.789 16.1699 13.6757 15.4795 12.9853L10.4942 8Z" fill="#767D81"/>
            </svg>  
        </div>
        
    )
}



// WEBPACK FOOTER //
// ./src/components/onboarding/invite_member_row.jsx